export function cronometro(segundos: number): string {
  const s = Math.max(0, segundos)
  const h = Math.floor(s / 3600)
  const m = Math.floor((s % 3600) / 60)
  const seg = s % 60
  const partes = h > 0 ? [h, m, seg] : [m, seg]
  return partes.map((p) => String(p).padStart(2, "0")).join(":")
}

export function letra(indice: number): string {
  return String.fromCharCode(65 + indice)
}

export function dataCurta(iso: string | null): string {
  if (!iso) return "—"
  return new Date(iso).toLocaleDateString("pt-BR", { day: "2-digit", month: "short", year: "numeric" })
}

// Nota na régua da prova real: 0 a 10, com vírgula e uma casa. "7.5" seria um
// número de sistema; o candidato lê 7,5.
export function nota(valor: number | null | undefined): string {
  if (valor === null || valor === undefined) return "—"
  return valor.toFixed(1).replace(".", ",")
}

// "1 ano" em vez de "12 meses": é como a pessoa pensa o prazo do pacote, e
// "12 meses" soa a plano de operadora. Os unitários seguem em "6 meses".
export function prazo(meses: number): string {
  return meses === 12 ? "1 ano" : `${meses} meses`
}

// Sem centavos quando não há: "R$ 97", não "R$ 97,00". O 97 é o único preço
// da escada sem ",90", e isso o faz parecer outra decisão, não uma variação —
// desde que a tela não devolva os centavos.
export function reais(centavos: number): string {
  const inteiro = centavos % 100 === 0
  return (centavos / 100).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: inteiro ? 0 : 2,
    maximumFractionDigits: inteiro ? 0 : 2,
  })
}

// "ou 3× de R$ 32,33 sem juros". Parcela não é mensalidade: o preço cheio vem
// sempre primeiro, e isto é a alternativa de pagamento — nunca o preço (ver
// CLAUDE.md, "nenhuma tela divide o valor por mês"). Vazio quando o cartão
// não está sendo oferecido (`parcelas` nulo) ou quando a parcela ficaria
// abaixo de R$ 10 — "3× de R$ 6,63" numa renovação de 19,90 só faz o preço
// parecer menor do que é.
const PARCELA_MINIMA = 1000
export function parcelado(centavos: number, parcelas: number | null | undefined): string | null {
  if (!parcelas || parcelas < 2) return null
  const parcela = Math.round(centavos / parcelas)
  if (parcela < PARCELA_MINIMA) return null
  return `ou ${parcelas}× de ${reais(parcela)} sem juros`
}
